<template>
  <!-- <keep-alive> -->
  <router-view />
  <!-- </keep-alive> -->
</template>

<script>
import pageComponent from '@/mixins/page-component';

export default {
  name: 'RestResourcesIdParentPage',
  mixins: [pageComponent],
  props: {
    id: { type: String, required: true },
  },
  inject: ['config'],
  computed: {
    namespace() { return `${this.config.store.namespace}/${this.id}`; },
  },
  created() {
    const { store, server } = this.config;
    const { modules } = store;
    this.$store.registerModule(this.namespace.split('/'), modules.id({ ...store, server, props: { id: this.id } }));
    this.fetchData();
  },
  destroyed() {
    this.$store.unregisterModule(this.namespace.split('/'));
  },
  methods: {
    async fetchData() {
      try {
        await this.fetchResource();
      } catch (e) {
        throw e;
      }
    },
    fetchResource() { this.$store.dispatch(`${this.namespace}/fetchResource`); },
  },
};
</script>

<style scoped>
</style>
